module.exports = __webpack_public_path__ + "static/media/logo-gets.992f11f5.svg";